import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import shortid from 'shortid'

import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import Intro from '../components/intro'
import Row, { Slot } from '../components/row'
import Calendar from '../components/calendar'
import CalendarListView from '../components/calendar-list-view'
import useResize from '../hooks/useResize'
import Input from '../components/input'
import styles from '../component-styles/date-range-tabs.module.scss'
import { getExplainSetup } from '../store/actions'

interface TabsProp {
  onChange: () => void
  showListView: boolean
}

export function Tabs({ showListView, onChange }: TabsProp): React.ReactElement {
  return (
    <div className={styles.tabsWrapper}>
      <Input
        name="select-view"
        id={shortid.generate()}
        label="Calendar"
        type="radio"
        value="c"
        checked={!showListView}
        onClick={(): any => {
          onChange()
        }}
      />
      <Input
        name="select-view"
        id={shortid.generate()}
        label="Timeline"
        type="radio"
        value="t"
        checked={!!showListView}
        onClick={(): any => {
          onChange()
        }}
      />
    </div>
  )
}

export default function CalendarPage(): React.ReactElement {
  const dispatch = useDispatch()

  const [width, setWidth] = useState(1500)
  const [showListView, setShowListView] = useState(true)
  const nextWidth = useResize()
  const nextHeight = useResize('height')
  const explainData = useSelector((s: any): any => s.explain)

  useEffect((): void => {
    if (explainData.pageLayout.length === 0) {
      dispatch(getExplainSetup())
    }
    // eslint-disable-next-line
  }, [])

  useEffect((): void => {
    if (nextHeight < 700) {
      setWidth(800)
    } else if (nextHeight < 800) {
      setWidth(900)
    } else if (nextHeight < 900) {
      setWidth(1000)
    } else if (nextHeight < 1000) {
      setWidth(1200)
    } else if (nextHeight < 1200) {
      setWidth(1280)
    }
  }, [nextWidth, nextHeight, width])

  if (showListView) {
    return (
      <SiteWrapper>
        <Layout>
          <Intro title="Timeline report">
            <p>
              A website overview you can share with your stakeholders. Click on
              a day to save important events which effect your websites
              performance.
            </p>
          </Intro>
          <Tabs
            showListView={showListView}
            onChange={() => {
              setShowListView(false)
            }}
          />
          <Row style={{ paddingBottom: 20 }} width={width}>
            <Slot>
              <CalendarListView />
            </Slot>
          </Row>
        </Layout>
      </SiteWrapper>
    )
  }

  return (
    <SiteWrapper>
      <Layout>
        <Intro title="Monthly report">
          <p>
            A website overview you can share with your stakeholders. Click on a
            day to save important events which effect your websites performance.
          </p>
        </Intro>
        <Tabs
          showListView={showListView}
          onChange={() => {
            setShowListView(true)
          }}
        />
        <Row style={{ paddingBottom: 20 }} width={width}>
          <Slot>
            <Calendar />
          </Slot>
        </Row>
      </Layout>
    </SiteWrapper>
  )
}
